import {Selectable} from '../Selectable';
import {IntermediatePost} from './IntermediatePost';
import { EmptyRect } from './EmptyRect';

export class SelectableIntermediatePost extends Selectable {

  public scaleCor;
  private picture: any;
  public modifiedAtStep3: boolean = false;

  constructor(edge: Feeney.IEdge, im) {
    super();
    this.picture = im;
    this.add(new IntermediatePost(edge, im));
    this.scaleCor = 1;
  }

  private getNestedPost(): IntermediatePost {
    return this.getObjectByName<IntermediatePost>(IntermediatePost.Name);
  }

  getBoundingBoxObjects(): Array<any> {
    return [this.getObjectByName<EmptyRect>(EmptyRect.Name)];
  }

  update() {
    this.getNestedPost().scaleCor = this.scaleCor;
    this.getNestedPost().update();
  }

  get edge() {
    return this.getNestedPost().edge;
  }

  getSize(): number {
    return this.getNestedPost().getSize();
  }

  getInfo() {
    let pos = {
      x: this.position.x,
      y: this.position.y,
      z: this.position.z
    };
    let rot = {
      x: this.rotation.x,
      y: this.rotation.y,
      z: this.rotation.z
    }
    return {
      type: "Post",
      position: pos,
      rotation: rot,
      scaleCor: this.scaleCor,
      typeP: { postType: "IN", labelPosition: "Center" },
      imageSrc: this.picture ? this.picture.src : undefined
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Post/SelectableIntermediatePost.ts